import { useCallback, useMemo, useRef } from 'react';
export const useFunctionsManager = () => {
  const subscribers = useRef({});
  const addFunctionSubscriber = useCallback((fnName, subscriber) => {
    const functionSubscribers = new Set(subscribers.current[fnName]);
    functionSubscribers.add(subscriber);
    subscribers.current[fnName] = functionSubscribers;
  }, []);
  const removeFunctionSubscriber = useCallback((fnName, subscriber) => {
    const functionSubscribers = new Set(subscribers.current[fnName]);
    functionSubscribers.delete(subscriber);
    subscribers.current[fnName] = functionSubscribers;
  }, []);
  const notifyFunctionSubscribers = useCallback((fnName, args) => {
    const functionSubscribers = new Set(subscribers.current[fnName]);
    functionSubscribers.forEach(subscriber => subscriber(args));
  }, []);
  return useMemo(() => ({
    addFunctionSubscriber,
    removeFunctionSubscriber,
    notifyFunctionSubscribers
  }), [addFunctionSubscriber, notifyFunctionSubscribers, removeFunctionSubscriber]);
};